import React, { useEffect } from 'react';
import { ArrowRight } from 'lucide-react';
interface FormButtonsProps {
  onPrevious: () => void;
  onNext: () => void;
  isNextDisabled?: boolean;
  nextText?: string;
  nextIcon?: React.ReactNode;
}
export const FormButtons: React.FC<FormButtonsProps> = ({
  onPrevious,
  onNext,
  isNextDisabled = false,
  nextText = 'Volgende',
  nextIcon = <ArrowRight className="ml-2 h-5 w-5" data-id="element-725" />
}) => {
  // Add a subtle entrance animation when the component mounts
  useEffect(() => {
    const buttonContainer = document.getElementById('sticky-form-buttons');
    if (buttonContainer) {
      buttonContainer.style.transform = 'translateY(100%)';
      buttonContainer.style.opacity = '0';
      setTimeout(() => {
        buttonContainer.style.transform = 'translateY(0)';
        buttonContainer.style.opacity = '1';
      }, 300);
    }
  }, []);
  return <>
      {/* Add substantial padding at the bottom to prevent content from being hidden behind the fixed buttons */}
      <div className="pb-24 md:pb-28" data-id="element-726"></div>
      {/* Fixed buttons that are always visible at the bottom with high z-index */}
      <div id="sticky-form-buttons" className="fixed bottom-0 left-0 right-0 z-[9999] p-4 md:p-6 transition-all duration-500" style={{
      background: 'linear-gradient(to top, rgba(0,0,0,0.95), rgba(0,0,0,0.85))',
      backdropFilter: 'blur(10px)',
      boxShadow: '0 -8px 20px rgba(0,0,0,0.25)',
      borderTop: '1px solid rgba(255,255,255,0.1)'
    }} data-id="element-727">
        <div className="container mx-auto max-w-3xl flex flex-col sm:flex-row gap-3 sm:justify-between" data-id="element-728">
          <button onClick={onPrevious} className="px-6 py-3.5 bg-white/15 hover:bg-white/25 text-white rounded-md transition-colors flex-grow sm:flex-grow-0 font-medium" data-id="element-729">
            Vorige stap
          </button>
          <button onClick={onNext} disabled={isNextDisabled} className={`px-6 py-3.5 rounded-md transition-all flex items-center justify-center flex-grow sm:flex-grow-0 font-medium ${isNextDisabled ? 'bg-gray-500/50 text-white/50 cursor-not-allowed' : 'bg-[#CDA735] hover:bg-[#B89429] text-white shadow-md hover:shadow-lg animate-pulse-subtle'}`} data-id="element-730">
            <span data-id="element-731">{nextText}</span>
            {nextIcon}
          </button>
        </div>
      </div>
      {/* Add pulse animation */}
      <style jsx data-id="element-732">{`
        @keyframes pulse-subtle {
          0% {
            box-shadow: 0 0 0 0 rgba(205, 167, 53, 0.4);
          }
          70% {
            box-shadow: 0 0 0 10px rgba(205, 167, 53, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(205, 167, 53, 0);
          }
        }
        .animate-pulse-subtle {
          animation: pulse-subtle 2s infinite;
        }
      `}</style>
    </>;
};